import { cryptoId, toJSON } from "@models/utils";
export class Discount {
    constructor(params) {
        this.ticketId = params.ticketId;
        this.price = params.price;
        this.id = params.id || cryptoId(4);
        this.usedAt = params.usedAt || 0;
        this.reusable = !!params.reusable;
        this.remainingUses = this.reusable
            ? -1
            : params.remainingUses !== undefined
                ? params.remainingUses
                : this.usedAt
                    ? 0
                    : 1;
    }
    get json() {
        return toJSON(this);
    }
    isValid(ticketTypes) {
        const isValid = ticketTypes.includes(this.ticketId) &&
            (this.remainingUses > 0 || this.reusable);
        return isValid;
    }
    invalidMessage(ticketTypes) {
        if (!ticketTypes.includes(this.ticketId)) {
            return "Invalid ticket type";
        }
        if (this.remainingUses === 0 && !this.reusable) {
            return "Discount code has been used";
        }
        return "Invalid discount code";
    }
}
